import { motion } from "framer-motion";
import { ArrowRight, MapPin, MessageCircle, Phone } from "lucide-react";
import { MAPS_URL, PHONE, logClick, openWhatsApp, trackEvent } from "@/lib/site";

const EASE = [0.16, 1, 0.3, 1];

export const VisitSection = () => (
  <section className="contact-band" id="visit" data-testid="visit-section">
    <div>
      <p className="chapter"><b>03</b> Your night, sorted</p>
      <h2>Let’s make<br/><em>it happen.</em></h2>
    </div>
    <motion.div className="contact-actions"
      initial={{ opacity: 0, y: 44 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, ease: EASE }}>
      <button onClick={() => openWhatsApp()} className="contact-action" data-testid="contact-whatsapp-button"><MessageCircle/><span><small>WhatsApp us</small>Quick table reservations</span><ArrowRight/></button>
      <a href={`tel:${PHONE.replaceAll(" ", "")}`} onClick={() => { trackEvent("call_click", { phone: PHONE }); logClick("call"); }} className="contact-action" data-testid="contact-call-link"><Phone/><span><small>Call the club</small>{PHONE}</span><ArrowRight/></a>
      <a href={MAPS_URL} target="_blank" rel="noreferrer" onClick={() => { trackEvent("directions_click"); logClick("directions"); }} className="contact-action address" data-testid="contact-directions-link"><MapPin size={20}/><span><small>Get directions</small>Calangute–Baga Rd, Baga, Arpora, Goa · Open 9 PM onwards</span><ArrowRight/></a>
    </motion.div>
  </section>
);
